/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import { withStyles, createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import moment from 'moment';
import ListAltRoundedIcon from '@material-ui/icons/ListAltRounded';
import { Grid, TableCell, TableRow } from '@material-ui/core';
import { connect } from 'react-redux';
import StoreIcon from '@material-ui/icons/Store';
import { mainColor, UNIT } from '../../constants/theme';
import Paper from '../Paper';
import { displayPriceFormat } from '../../utils/tools';
import { styles } from './OrderItem.styles';
import {
  TECHS_LOGO,
  backColor,
  ORDER_TYPE_DELIVERY,
  SUITABLE_ORDER_TYPES,
  ORDER_PHASE_PREPARING_LABEL,
  ICON_ORDER_TYPES,
  ORDER_COMPLETED_LABEL,
  ORDER_MISSED_LABEL,
  ORDER_TYPE_SEAT,
  ORDER_TYPE_COLLECT,
  ORDER_PHASE_CONTACTING,
  ORDER_REFUND_LABEL,
  ORDER_CANCELED_LABEL, ORDER_PHASE_DELIVERING_LABEL,
  ORDER_PHASE_PREPARING,
  DEFAULT_PREPARATION_TIME,
  ORDER_PHASE_DELIVERING_TIME
} from '../../constants';
import { isCompletedOrder, isExternalApp, setOpacity } from '../../utils/orderUtils';
import { displayDate, getDateFormat, suitableTime } from '../../utils/suitableDate';
import { updateTime, getPaidStatus, getSearchingDriverStatus } from './OrderItem.services';
import stopWatch from '../../assets/pictures/stopwatch.svg';
import clockIcon from '../../assets/pictures/clockIcon.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins, faCreditCard } from '@fortawesome/fontawesome-free-solid'
import { DEFAULT_SLOT_INTERVAL } from 'src/constants/dataConfig';
import { MOMENT_UNIT } from 'src/constants/date';
import { isDelivery } from '../OrderModal/OrderModal.service';
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 715,
      md: 960,
      lg: 1280,
      xl: 1650
    }
  }
});
const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 5,
    margin: '2px 0 10px 0 ',
    width: '75%',
    position: 'relative',
    borderRadius: 5
  },
  colorPrimary: {
    backgroundColor: mainColor.backGroundColor
  },
  colorSecondary: {
    backgroundColor: mainColor.backGroundColor
  },
  barColorPrimary: {
    backgroundColor: 'orange'
  },
  barColorSecondary: {
    backgroundColor: mainColor.colorRed
  },

  bar: {
    borderRadius: 5
  }
}))(LinearProgress);
const INITIAL_STATE = {
  order: {},
  diff: 0
};
class OrderItem extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  createTableRow = (diff, diffTime) => {
    const {
      classes,
      item = {},
      orderItem = {},
      onClick,
      filtredType,
      shops,
      isAllShops
    } = this.props;
    const {
      orderNumber = '',
      canal,
      date,
      totalPriceOrder,
      userNameDep,
      orderType,
      shopId,
      datePreparationEnded,
      status
    } = item;
    const statusLabel = getSearchingDriverStatus(item)
    return (
      <TableRow
        key={orderNumber}
        style={{
          backgroundColor:
            orderItem.orderNumber === orderNumber
              ? `${setOpacity(backColor[statusLabel], 0.4)}`
              : `${setOpacity(backColor[statusLabel], 0.25)}`
        }}
        onClick={onClick}
      >
        {isAllShops && (
          <TableCell align='center' className={classes.orderRow}>
            {shops[shopId]?.name || shopId || 'N/A'}
          </TableCell>
        )}
        <TableCell align='center' className={classes.orderRow}>
          <img src={TECHS_LOGO[canal.toLowerCase()]} alt='default' className={classes.canalImage} />
        </TableCell>
        <TableCell align='center' className={classes.orderRow}>
          {SUITABLE_ORDER_TYPES[orderType]}
        </TableCell>
        <TableCell align='center' className={classes.orderRow}>
          {orderNumber ? `#${orderNumber}` : ''}
        </TableCell>

        <TableCell align='center' className={classes.orderRow}>
          {`${displayDate(datePreparationEnded || date)}${suitableTime(moment(datePreparationEnded || date))}`}
          <br />
          {orderType === ORDER_TYPE_DELIVERY && status !== ORDER_PHASE_CONTACTING && (
            <span>{`Livraison pour ${suitableTime(moment(date).isAfter(moment(datePreparationEnded).add(ORDER_PHASE_DELIVERING_TIME, MOMENT_UNIT.MINUTE)) ? moment(date) : moment(datePreparationEnded).add(ORDER_PHASE_DELIVERING_TIME, MOMENT_UNIT.MINUTE))}`}</span>
          )}
        </TableCell>
        <TableCell
          align='center'
          className={classes.orderRow}
          style={{
            color: statusLabel === ORDER_MISSED_LABEL ? mainColor.colorRed : mainColor.colorBlack
          }}
        >
          {statusLabel}
          {statusLabel === ORDER_PHASE_PREPARING_LABEL && (
            <b
              className={classes.remainingTime}
              style={{
                color: diff <= 0 ? mainColor.colorRed : mainColor.colorBlack
              }}
            >{`${diff > 0 ? `Dans` : `Il y'a`} ${diffTime}`}</b>
          )}
        </TableCell>
        {filtredType === ORDER_TYPE_SEAT || filtredType === ORDER_TYPE_COLLECT ? null : (
          <TableCell align='center' className={classes.orderRow}>
            {orderType === ORDER_TYPE_DELIVERY ? userNameDep || 'Non defini ' : '--'}
          </TableCell>
        )}

        <TableCell align='center' className={classes.orderRow}>
          {displayPriceFormat(totalPriceOrder || 0)}
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const {
      onClick,
      classes,
      item = {},
      index,
      isGrid,
      orderItem = {},
      isAllShops,
      shops,
      hours
    } = this.props;
    const {
      orderNumber = '',
      canal,
      date,
      totalPriceOrder,
      userNameDep,
      orderType,
      shopId,
      datePreparationStarted,
      preparationTime,
      status,
      userLastNameDep = '',
      paymentType,
      externalOrderNumber
    } = item;
    const datePreparationEnded = moment(datePreparationStarted).add(preparationTime, MOMENT_UNIT.MINUTE).format();

    const statusLabel = getSearchingDriverStatus(item)
    const { progress, diff, diffTime } =
      statusLabel === ORDER_PHASE_PREPARING_LABEL ? updateTime(this) : {};
    const paidStatus = getPaidStatus(statusLabel, paymentType);
    return isGrid ? (
      <MuiThemeProvider theme={theme}>
        <Grid item key={index} xs={12} sm={6} md={4} lg={3} xl={3}>
          <div className='cardItem' style={{ height: '100%' }}>
            <Paper
              key={index}
              elevation={0}
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onClick();
              }}
              style={{ borderRadius: UNIT * 1.5, cursor: 'pointer' }}
              className={classes.paper}
            >
              <div
                className={classes.header}
                style={{
                  borderBottom: isCompletedOrder(statusLabel) && '1px solid gray',
                  borderColor: isCompletedOrder(statusLabel) && mainColor.backGroundColor,
                  backgroundColor: isCompletedOrder(statusLabel)
                    ? mainColor.colorWhite
                    : orderItem.orderNumber === orderNumber
                      ? `${setOpacity(backColor[statusLabel], 0.4)}`
                      : `${setOpacity(backColor[statusLabel], 0.25)}`
                }}
              >
                <div className={classes.orderText}>{`#${orderNumber} ${externalOrderNumber ? `(S-${externalOrderNumber})` : ''}`}</div>
              </div>
              <div className={classes.cardContent}>
                <div className='d-flex h-54 flex-column pl-4 mt-3 mt-sm-2 mt-md-3 ml-1 pb-1 justify-content-start align-items-start cardContent'>
                  {isAllShops && (
                    <>
                      <span className={classes.descriptionStyle}>
                        {' '}
                        <StoreIcon className='m-0 mr-2' />
                        <b>{shops?.[shopId]?.name || shopId || 'N/A'}</b>
                      </span>
                    </>
                  )}
                  <div className='d-flex align-items-center smallText'>
                    <div className='m-0 mr-2'>{ICON_ORDER_TYPES[orderType]}</div>

                    <b>
                      {SUITABLE_ORDER_TYPES[orderType]}
                      {orderType === ORDER_TYPE_DELIVERY &&
                        status !== ORDER_PHASE_CONTACTING &&
                        ` pour ${suitableTime(moment.max(moment(date), moment(datePreparationEnded).add(ORDER_PHASE_DELIVERING_TIME, MOMENT_UNIT.MINUTE)))}`}
                    </b>
                  </div>
                  <div className='d-flex align-items-center smallText'>
                    <img src={clockIcon} alt='display image' className={classes.clockIcon} />
                    {`Date client: ${moment().isSame(moment(date), MOMENT_UNIT.DAY) ? `${suitableTime(
                      moment(date)
                    )} - ${suitableTime(
                      moment(date).add(
                        hours?.slotInterval ?? DEFAULT_SLOT_INTERVAL, MOMENT_UNIT.MINUTE
                      )
                    )}` : getDateFormat(date)}`}
                  </div>

                  {status === ORDER_PHASE_PREPARING && <div className='d-flex align-items-center smallText'>
                    <img src={clockIcon} alt='display image' className={classes.clockIcon} />
                    {`${isDelivery(orderType) ? 'Arrivée livreur' : 'Sortie cuisine'}: ${suitableTime(moment.max(moment(date).subtract(isDelivery(orderType) ? ORDER_PHASE_DELIVERING_TIME : 0, MOMENT_UNIT.MINUTE), moment(datePreparationEnded)))} `}
                  </div>}
                  <div
                    className='d-flex align-items-center smallText'
                    style={{
                      color:
                        isCompletedOrder(statusLabel) &&
                        (statusLabel !== ORDER_COMPLETED_LABEL
                          ? mainColor.colorRed
                          : mainColor.secondaryColor)
                    }}
                  >
                    <ListAltRoundedIcon className='m-0 mr-2' /> {statusLabel}{' '}
                    {orderType === ORDER_TYPE_DELIVERY &&
                      userNameDep &&
                      statusLabel !== ORDER_REFUND_LABEL &&
                      statusLabel !== ORDER_CANCELED_LABEL && statusLabel === ORDER_PHASE_DELIVERING_LABEL &&
                      `  par ${`${userLastNameDep !== ''
                        ? `${userLastNameDep.slice(0, 1).toUpperCase()}.`
                        : ''
                      }${userNameDep}`}`}
                  </div>

                  <div className='d-flex align-items-center smallText'>
                    <FontAwesomeIcon icon={paymentType === 'cash' ? faCoins : faCreditCard} className={` ml-1 ${classes.paidIcon}`} />
                    {paidStatus}

                  </div>
                </div>
                {!isAllShops &&
                  statusLabel === ORDER_PHASE_PREPARING_LABEL &&
                  !isExternalApp(canal) && (
                    <div className={classes.progressBar}>
                      <b style={{ fontSize: UNIT * 0.6875 }}>
                        <img src={stopWatch} alt='display image' className={classes.img} />
                        {`Temps  ${diff < 0 ? 'dépassé' : 'restant'}  : ${diffTime}`}
                      </b>
                      <BorderLinearProgress
                        color={diff < 0 ? 'secondary' : 'primary'}
                        variant='determinate'
                        value={diff < 0 ? 100 : progress}
                      />
                    </div>
                  )}
              </div>

              <div className={classes.footer}>
                <div className={classes.arroundIcon}>
                  <img src={TECHS_LOGO[canal.toLowerCase()]} alt='' />
                </div>
                <div
                  className={classes.total}
                  style={{
                    backgroundColor: isCompletedOrder(statusLabel)
                      ? mainColor.backGroundColor
                      : `${setOpacity(backColor[statusLabel], 0.1)}`
                  }}
                >
                  <b
                    style={{
                      color: isCompletedOrder(statusLabel)
                        ? mainColor.colorBlack
                        : `${setOpacity(backColor[statusLabel], 1)}`
                    }}
                  >
                    Total : {displayPriceFormat(totalPriceOrder || 0)}
                  </b>
                </div>
              </div>
            </Paper>
          </div>
        </Grid>
      </MuiThemeProvider>
    ) : (
      this.createTableRow(diff, diffTime)
    );
  }
}
const mapStateToProps = ({ user, firebaseRealTime }) => {
  const { generalConfig = {}, shops = {}, } = firebaseRealTime;
  const { marketplace = {}, hours = {} } = generalConfig;
  const { isAllShops, shopId } = user;
  return {
    marketplace,
    isAllShops,
    shopId,
    shops,
    hours
  };
};
export default connect(mapStateToProps, null)(withStyles(styles)(OrderItem));
